import { useState } from "react";
import { useTranslation } from "react-i18next";
import Menu from "src/components/Menu";
import MenuItemText from "src/components/Menu/ItemText";
import MenuItem from "src/components/Menu/Item";
import { ReactComponent as MoreIcon } from "src/icons/more-horiz.svg";

export default function BuyMenu({ openRestore, isDisabled, fill = "white" }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Menu
      isDisabled={isDisabled}
      elevationLevel={2}
      isOpen={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      icon={MoreIcon}
      iconFill={fill}
      iconSize="20px"
    >
      <MenuItem onClick={openRestore} my="8px">
        <MenuItemText>{t("enterCode")}</MenuItemText>
      </MenuItem>
    </Menu>
  );
}
